import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Bell, BellOff, BellRing } from "lucide-react";
import { pushSupported, getPushStatus, subscribeToPush, unsubscribeFromPush } from "@/lib/push";
import { Button } from "@/components/ui/button";

export default function PushSubscribeButton({ variant = "default" }) {
  const [state, setState] = useState({ supported: false, subscribed: false, permission: "default" });
  const [busy, setBusy] = useState(false);

  const refresh = () => getPushStatus().then(setState);
  useEffect(() => { refresh(); }, []);

  if (!state.supported && variant !== "default") return null;

  const handle = async () => {
    if (!pushSupported()) {
      toast.error("आपका ब्राउज़र पुश सूचनाएँ सपोर्ट नहीं करता");
      return;
    }
    setBusy(true);
    try {
      if (state.subscribed) {
        await unsubscribeFromPush();
        toast.success("पुश सूचनाएँ बंद कर दी गयीं");
      } else {
        await subscribeToPush();
        toast.success("धन्यवाद! अब आपको ब्रेकिंग न्यूज़ की तुरंत सूचना मिलेगी");
      }
      await refresh();
    } catch (e) {
      toast.error(e.message || "कुछ गड़बड़ हुई");
    } finally {
      setBusy(false);
    }
  };

  const label = state.subscribed ? "सूचनाएँ बंद करें" : "ब्रेकिंग न्यूज़ अलर्ट पाएँ";
  const Icon = state.subscribed ? BellRing : Bell;

  if (variant === "hero") {
    return (
      <Button onClick={handle} disabled={busy}
        className={`${state.subscribed ? "bg-emerald-600 hover:bg-emerald-700" : "bg-[#DC2626] hover:bg-[#B91C1C]"} text-white font-bold shadow-lg`}
        data-testid="push-subscribe-btn">
        <Icon className="w-4 h-4 mr-2"/>{busy ? "…" : label}
      </Button>
    );
  }

  return (
    <button onClick={handle} disabled={busy}
      className={`inline-flex items-center gap-2 text-xs font-admin uppercase tracking-widest px-3 py-1.5 rounded-full border transition ${
        state.subscribed
          ? "border-emerald-500 text-emerald-700 bg-emerald-50 hover:bg-emerald-100"
          : "border-[#DC2626] text-[#DC2626] hover:bg-[#DC2626] hover:text-white"
      }`}
      data-testid="push-subscribe-btn">
      <Icon className="w-3.5 h-3.5"/>{busy ? "…" : label}
    </button>
  );
}
